import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mdc-form-field flex items-start" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id", "name"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"mdc-checkbox__background\"><svg class=\"mdc-checkbox__checkmark\" viewBox=\"0 0 24 24\"><path class=\"mdc-checkbox__checkmark-path\" fill=\"none\" d=\"M1.73,12.91 8.1,19.28 22.79,4.59\"></path></svg><div class=\"mdc-checkbox__mixedmark\"></div></div><div class=\"mdc-checkbox__ripple\"></div>", 2)
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("label", {
        class: _normalizeClass([[
				_ctx.disabled ? '' : 'checkbox-container',
				'relative  flex space-x-1.5 items-start ',
				_ctx.optionClass,
				_ctx.itemClass,
			], "checkbox-item"]),
        key: _ctx.id + '-checkbox-' + index
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            id: _ctx.id + '-checkbox-' + index,
            class: "mdc-checkbox"
          }, [
            _createElementVNode("input", {
              id: _ctx.id + '-checkbox-' + index + '-native',
              type: "checkbox",
              class: "mdc-checkbox__native-control",
              name: _ctx.id
            }, null, 8, _hoisted_3),
            _hoisted_4
          ], 8, _hoisted_2),
          _createElementVNode("label", {
            for: _ctx.id + '-checkbox-' + index + '-native',
            class: "mt-2.5"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", {
                  class: "",
                  innerHTML: option.content
                }, null, 8, _hoisted_9),
                _renderSlot(_ctx.$slots, "itemSide", { option: option })
              ]),
              _renderSlot(_ctx.$slots, "item", {
                description: option.description
              })
            ])
          ], 8, _hoisted_6)
        ])
      ], 2))
    }), 128))
  ]))
}